var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weater_content"},[_c('iframe',{staticStyle:{"margin-top":"2rem"},attrs:{"src":"","width":"100%","height":_vm.height,"frameborder":"0","scrolling":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }